export const IMAGE_OUTPUTS = [
  { value: 'jpg', label: 'JPG' },
  { value: 'png', label: 'PNG' },
  { value: 'webp', label: 'WEBP' },
  { value: 'avif', label: 'AVIF' }
];

export const VIDEO_OUTPUTS = [
  { value: 'mp4', label: 'MP4 (H.264/AAC)' },
  { value: 'webm', label: 'WEBM (VP9/Opus)' },
  { value: 'mkv', label: 'MKV' },
  { value: 'mov', label: 'MOV' },
  { value: 'avi', label: 'AVI' },
  { value: 'gif', label: 'GIF' },
  { value: 'mp4_normalize', label: 'MP4 Normalize/Fix playback' }
];

export const PRESET_DETAILS = {
  jpg: {
    type: 'image',
    ext: 'jpg',
    ffmpegArgs: ['-q:v', '2']
  },
  png: {
    type: 'image',
    ext: 'png',
    ffmpegArgs: []
  },
  webp: {
    type: 'image',
    ext: 'webp',
    ffmpegArgs: ['-quality', '85']
  },
  avif: {
    type: 'image',
    ext: 'avif',
    ffmpegArgs: ['-crf', '30']
  },
  mp4: {
    type: 'video',
    ext: 'mp4',
    ffmpegArgs: ['-c:v', 'libx264', '-preset', 'medium', '-crf', '22', '-c:a', 'aac', '-movflags', '+faststart']
  },
  webm: {
    type: 'video',
    ext: 'webm',
    ffmpegArgs: ['-c:v', 'libvpx-vp9', '-crf', '35', '-b:v', '0', '-c:a', 'libopus']
  },
  mkv: {
    type: 'video',
    ext: 'mkv',
    ffmpegArgs: ['-c:v', 'libx264', '-crf', '22', '-c:a', 'aac']
  },
  mov: {
    type: 'video',
    ext: 'mov',
    ffmpegArgs: ['-c:v', 'libx264', '-crf', '22', '-c:a', 'aac']
  },
  avi: {
    type: 'video',
    ext: 'avi',
    ffmpegArgs: ['-c:v', 'mpeg4', '-qscale:v', '3', '-c:a', 'libmp3lame']
  },
  gif: {
    type: 'video',
    ext: 'gif',
    ffmpegArgs: ['-vf', 'fps=12,scale=trunc(iw/2)*2:trunc(ih/2)*2:flags=lanczos', '-loop', '0']
  },
  mp4_normalize: {
    type: 'video',
    ext: 'mp4',
    ffmpegArgs: [
      '-map',
      '0:v:0',
      '-map',
      '0:a:0?',
      '-vf',
      'scale=trunc(iw/2)*2:trunc(ih/2)*2',
      '-c:v',
      'libx264',
      '-pix_fmt',
      'yuv420p',
      '-profile:v',
      'high',
      '-level',
      '4.1',
      '-preset',
      'slow',
      '-crf',
      '20',
      '-g',
      '48',
      '-keyint_min',
      '48',
      '-sc_threshold',
      '0',
      '-c:a',
      'aac',
      '-ar',
      '48000',
      '-b:a',
      '192k',
      '-movflags',
      '+faststart'
    ]
  }
};

export const isImageFile = (file) => file?.type?.startsWith('image/');
export const isVideoFile = (file) => file?.type?.startsWith('video/');
